import React, { Component } from "react";
import {
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Container
} from "semantic-ui-react";

import * as LINKS from "../assets/Links";

class AdminLogin extends Component {
  state = {
    email: "",
    password: "",
    success: false,
    redirect: "/#/VrfHpcV3wHQHFD5"
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit = () => {
    // console.log(this.state.email + " " + this.state.password);
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.adminLogin, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password
      })
    })
      .then(resp => resp.json())
      .then(data => {
        if (!data["jwt_token"]) {
          console.log(data);
        } else {
          console.log(data);
          localStorage.setItem("dat", data["jwt_token"]);
          localStorage.setItem("id", data["id"]);
          localStorage.setItem("email", data["email"]);
          this.setState({ success: true });
          if (data.redirect) {
            console.log("With Great Power comes Great Responsibility");
            this.setState({ redirect: "#/vpMUN7G54pff7CA7" });
          }
        }
      });
  };

  render() {
    const { email, password } = this.state;
    return (
      <Grid centered verticalAlign="middle">
        <Container text textAlign="center">
          <Header as="h2" textAlign="center" style={{ marginTop: "3em" }}>
            With Great Power comes Great Responsibility
          </Header>
          <Grid centered verticalAlign="middle">
            <Grid.Column>
              <Segment>
                <Form
                  size="large"
                  /* action='#/team' */ onSubmit={this.handleSubmit}
                >
                  <Form.Input
                    fluid
                    name="email"
                    icon="user"
                    iconPosition="left"
                    placeholder="Email address"
                    value={email}
                    onChange={this.handleChange}
                  />
                  <Form.Input
                    fluid
                    name="password"
                    icon="lock"
                    iconPosition="left"
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={this.handleChange}
                  />
                  <Message positive success={!this.state.success}>
                    <Message.Header>Welcome</Message.Header>
                    <Message.Content>
                      <a href={this.state.redirect}>Go to your dashboard</a>
                    </Message.Content>
                  </Message>
                  {/* jwt_token */}
                  <Form.Button
                    color="black"
                    fluid
                    size="large"
                    type="submit"
                    disabled={!this.state.email || !this.state.password}
                  >
                    Open
                  </Form.Button>
                </Form>
              </Segment>
              <Message>
                <a href="/">Don't know what to do here? Let's go back home</a>
              </Message>
            </Grid.Column>
          </Grid>
        </Container>
      </Grid>
    );
  }
}

export default AdminLogin;
